/// @flow
import React, { PureComponent } from 'react';

import ErrorMessage from 'components/fragments/ErrorMessage';
import { dynamicClassName } from 'utils/dynamicClassName';

import './DropdownMultiInput.css';

type Props = {
  id: string,
  options: any[],
  label: string,
  counter?: number,
  inputChanged: (value: string) => void,
  selected: Array<any>,
  className?: string,
  closeOnSelect: boolean,
  isLight?: boolean,
  hasError?: boolean,
  errorMessage?: string
};

type State = {
  isOpen: boolean
};

class DropdownMultiInput extends PureComponent<Props, State> {
  props: Props;
  wrapperRef: any;

  static defaultProps = {
    id: 'ID',
    label: 'Label',
    options: [
      {
        value: 'option1',
        label: 'option1'
      }
    ],
    counter: 0,
    closeOnSelect: false
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  render() {
    const { isOpen } = this.state;
    const { className, errorMessage, hasError, isLight } = this.props;

    let classNames;

    if (className) {
      classNames = dynamicClassName(className);
    } else {
      classNames = dynamicClassName('dropdown dropdown--accordion mb-3');
    }

    isOpen && classNames.add('is-open');
    isLight && classNames.add('is-light');
    hasError && classNames.add('has-error');
    this.props.selected.length > 0 && classNames.add('has-counter');
    return (
      <>
        <div className={classNames.build()} ref={this.setWrapperRef}>
          <span role="button" tabIndex={0} className="dropdown__head ft-h6 ft-up" onClick={this.handleClickDropDown}>
            <span className="dropdown__label">{this.props.label}</span>
            <span className="dropdown__counter">({this.props.selected.length})</span>
          </span>
          <div className="dropdown__list">
            <span role="button" tabIndex={0} className="dropdown__head ft-h6 ft-up" onClick={this.handleClickDropDown}>
              <span className="dropdown__label">{this.props.label}</span>
              <span className="dropdown__counter">({this.props.selected.length})</span>
            </span>
            <div className="dropdown__wrapper">{this.renderOptions(this.props.options)}</div>
          </div>
        </div>

        {hasError && errorMessage && <ErrorMessage forceDisplay message={errorMessage} />}
      </>
    );
  }

  renderOptions = (options: any) => {
    return options.map((option, index) => {
      if (!option.value) {
        return <span key={index}>{option.label}</span>;
      }

      return (
        <div className="checkbox" key={index}>
          <input
            type="checkbox"
            id={this.props.id + index}
            onChange={this.handleSelected(option.value)}
            checked={this.props.selected.includes(option.value)}
          />
          <label htmlFor={this.props.id + index}>{option.label}</label>
        </div>
      );
    });
  };

  handleClickDropDown = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  setWrapperRef = (node: any) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event: MouseEvent) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  handleSelected = (value: string) => {
    return () => {
      if (this.props.closeOnSelect) {
        this.setState(prevState => ({
          isOpen: false
        }));
      }
      this.props.inputChanged(value);
    };
  };
}

export default DropdownMultiInput;
